export const Reports = [
  {
    name: 'Companies usages',
    value: 'clients_montly_usage',
    description:
      'Report for getting amount of checks (by type) used by companies in the chosen period.',
    row_description: 'Company',
    columns: [
      { name: 'ID', description: 'Company ID' },
      { name: 'Company', description: 'Company Name' },
      { name: 'Owner email', description: 'Company main user email' },
      { name: 'Brand', description: 'Brand name' },
      { name: '...{Check title}', description: 'Check usage count *' },
    ],
    notes: ['* Filter by submitted date if `reference` type, else use completed date'],
  },
  {
    name: 'Companies checks usages',
    value: 'checks_usage',
    description:
      'Report for getting amount of checks (by type) used in the chosen period. One row per billing entity and check type, so team, brand, or option invoicing produces a row per billing entity.',
    row_description: 'Billing entity check',
    columns: [
      { name: 'billing_entity_id', description: 'Billing entity ID' },
      {
        name: 'billing_entity_name',
        description:
          'Company name when the company is invoiced as a whole, including each company in a group. Brand, team, or custom entity name when billing is split that way.',
      },
      { name: 'invoice_entity_name', description: 'Name printed on the invoice' },
      { name: 'invoice_entity_email', description: 'Invoice email' },
      { name: 'invoice_entity_region', description: 'Invoice region' },
      { name: 'invoice_entity_post_code', description: 'Invoice postcode' },
      { name: 'invoice_entity_country', description: 'Invoice country' },
      { name: 'company_id', description: 'Company ID' },
      { name: 'company_name', description: 'Company Name' },
      { name: 'account_type', description: 'Company account type' },
      { name: 'payment_type', description: 'Company check payment type' },
      { name: 'account_manager', description: 'Account manager' },
      { name: 'poc_name', description: 'Company main user name' },
      { name: 'poc_email', description: 'Company main user email' },
      { name: 'check_type', description: 'Check title' },
      { name: 'check_slug', description: 'Check code' },
      { name: 'credits', description: 'Company check credits' },
      { name: 'billing_currency', description: 'Billing currency' },
      { name: 'pricing', description: 'Company check pricing if custom, else check pricing' },
      {
        name: 'completed_checks',
        description:
          'Count completed as at the report period end (not canceled at period end). Excludes bill-per-subcheck checks with no subchecks',
      },
      {
        name: 'in_progress_checks',
        description:
          'Count in progress as at the report period end (not completed or canceled at period end). Excludes bill-per-subcheck checks with no subchecks',
      },
      {
        name: 'canceled_checks',
        description:
          'Count canceled as at the report period end (check canceled_at or candidate canceled), excluding no-charge checks. Excludes bill-per-subcheck checks with no subchecks',
      },
      {
        name: 'no_charge_checks',
        description:
          'Count of checks tagged no charge (no SSN, below minimum age, or has not lived in the required country). Price is 0 on the billing report. Excludes bill-per-subcheck checks with no subchecks',
      },
      {
        name: 'total_checks',
        description:
          'Total count of check type in the billing period. Excludes bill-per-subcheck checks with no subchecks',
      },
      {
        name: 'completed_subchecks',
        description:
          'Sum of completed subchecks as at period end for subcheck-priced check types; 0 otherwise',
      },
      {
        name: 'in_progress_subchecks',
        description:
          'Sum of in-progress subchecks as at period end for subcheck-priced check types; 0 otherwise',
      },
      {
        name: 'canceled_subchecks',
        description:
          'Sum of canceled subchecks for subcheck-priced check types, excluding checks tagged no charge; 0 otherwise',
      },
      {
        name: 'no_charge_subchecks',
        description:
          'Sum of subchecks on checks tagged no charge, for subcheck-priced check types; 0 otherwise',
      },
      {
        name: 'total_subchecks',
        description:
          'Total subchecks for billed checks when pricing mode is subcheck_standard, subcheck_variable, or subcheck_fixed; 0 for other check types',
      },
    ],
  },
  {
    name: 'Billing Report',
    value: 'checks_usage_billing',
    description: 'Billing report for checks usages in the chosen period.',
    row_description: 'Billing line',
    columns: [
      { name: 'billing_entity_id', description: 'Billing entity ID' },
      {
        name: 'billing_entity_name',
        description:
          'Company name when the company is invoiced as a whole, including each company in a group. Brand, team, or custom entity name when billing is split that way.',
      },
      { name: 'invoice_entity_name', description: 'Name printed on the invoice' },
      { name: 'invoice_entity_email', description: 'Invoice email' },
      { name: 'invoice_entity_region', description: 'Invoice region' },
      { name: 'invoice_entity_post_code', description: 'Invoice postcode' },
      { name: 'invoice_entity_country', description: 'Invoice country' },
      { name: 'company_id', description: 'Company ID' },
      { name: 'company_name', description: 'Company Name' },
      { name: 'account_type', description: 'Company account type' },
      { name: 'payment_type', description: 'Company check payment type' },
      { name: 'candidate_id', description: 'Candidate ID' },
      { name: 'candidate_reference_code', description: 'Candidate reference code' },
      { name: 'candidate_name', description: 'Candidate name' },
      { name: 'candidate_email', description: 'Candidate email' },
      { name: 'candidate_job_role', description: 'Candidate job role' },
      { name: 'candidate_department', description: 'Candidate department' },
      { name: 'brand_id', description: 'Candidate brand ID' },
      { name: 'brand_name', description: 'Candidate brand name' },
      { name: 'team_id', description: 'Candidate team ID' },
      { name: 'team_name', description: 'Candidate team name' },
      { name: 'assigned_user', description: 'Assigned user email' },
      { name: 'check_type', description: 'Check title' },
      { name: 'check_slug', description: 'Check code' },
      {
        name: 'renewal',
        description: 'Whether the candidate check was launched as a renewal',
      },
      { name: 'candidate_check_id', description: 'Candidate check ID' },
      {
        name: 'sub_check_id',
        description: 'Subcheck ID when billing_line_type is per_subcheck; empty otherwise',
      },
      {
        name: 'provider_id',
        description:
          'Provider ID on the subcheck when set, otherwise the candidate check provider ID',
      },
      {
        name: 'line_item_name',
        description:
          'Check title, subcheck title, item name, or additional charge name (depending on billing_line_type)',
      },
      { name: 'status', description: 'Parent candidate check status as at the report period end' },
      {
        name: 'sub_check_status',
        description: 'Subcheck status when billing_line_type is per_subcheck; empty otherwise',
      },
      { name: 'created_at', description: 'Check Created Date' },
      { name: 'submitted_at', description: 'Check Submitted Date' },
      { name: 'completed_at', description: 'Check Completed Date' },
      { name: 'canceled_at', description: 'Check Canceled Date' },
      { name: 'payment_status', description: 'Check Payment Status' },
      { name: 'payment_method', description: 'Check Payment Method' },
      { name: 'payment_status_updated_at', description: 'Check Payment Status Updated Date' },
      { name: 'billing_currency', description: 'Billing currency' },
      { name: 'price', description: 'Price for this billing line' },
      {
        name: 'no_charge',
        description: 'true when the check is tagged no charge and the price is 0',
      },
      {
        name: 'source',
        description:
          'Human-readable value label (e.g. Australia, Standard, Volunteer) or - when not applicable',
      },
      { name: 'source_value', description: 'Source value (raw code or -)' },
      {
        name: 'billing_line_type',
        description: 'per_check, per_subcheck, per_item, or additional_charge',
      },
    ],
  },
  {
    name: 'Xero billing',
    value: 'xero',
    description:
      "One row per billing entity, company, check type, billing line type, rate, and unit price. Standard and Volunteer stay on separate rows. A company in a group uses the group's invoice name and address. When the group gets one invoice, every row uses the parent company's billing entity id and keeps that company's name. When each company gets its own invoice, rows keep that company's billing entity. quantity is how many billing lines were charged at unit_price, and total_price is quantity times that rate. Status counts are the checks and subchecks on that rate. A check with subchecks at two rates is counted on each of those rows. Additional-charge rows do not repeat the check count. Same dates and prices as the billing report.",
    row_description: 'Billing entity check rate',
    columns: [
      { name: 'billing_entity_id', description: 'Billing entity ID' },
      {
        name: 'billing_entity_name',
        description:
          'Company name when the company is invoiced as a whole, including each company in a group. Brand, team, or custom entity name when billing is split that way.',
      },
      { name: 'invoice_entity_name', description: 'Name printed on the invoice' },
      { name: 'invoice_entity_email', description: 'Invoice email' },
      { name: 'invoice_entity_region', description: 'Invoice region' },
      { name: 'invoice_entity_post_code', description: 'Invoice postcode' },
      { name: 'invoice_entity_country', description: 'Invoice country' },
      { name: 'company_id', description: 'Company ID' },
      { name: 'company_name', description: 'Company Name' },
      { name: 'account_type', description: 'Company account type' },
      { name: 'payment_type', description: 'Company check payment type' },
      { name: 'check_type', description: 'Check title' },
      { name: 'check_slug', description: 'Check code' },
      { name: 'billing_currency', description: 'Billing currency' },
      {
        name: 'billing_line_type',
        description: 'per_check, per_subcheck, per_item, or additional_charge',
      },
      {
        name: 'rate',
        description:
          'Rate name, such as Standard, Volunteer, or a country. "-" when the check has a single unnamed rate',
      },
      { name: 'unit_price', description: 'Price charged for each billing line in this row' },
      {
        name: 'completed_checks',
        description: 'Checks on this rate completed as at the report period end',
      },
      {
        name: 'in_progress_checks',
        description: 'Checks on this rate still in progress as at the report period end',
      },
      {
        name: 'cancelled_charged_checks',
        description:
          'Checks on this rate canceled as at the report period end that are still charged',
      },
      {
        name: 'total_checks',
        description: 'completed_checks + in_progress_checks + cancelled_charged_checks',
      },
      {
        name: 'cancelled_no_charge_checks',
        description: 'Checks on this rate tagged no charge. Not included in total_checks',
      },
      {
        name: 'completed_subchecks',
        description: 'Subchecks on this rate completed as at the report period end',
      },
      {
        name: 'in_progress_subchecks',
        description: 'Subchecks on this rate still in progress as at the report period end',
      },
      {
        name: 'cancelled_charged_subchecks',
        description: 'Canceled subchecks on this rate whose check is still charged',
      },
      {
        name: 'total_subchecks',
        description:
          'completed_subchecks + in_progress_subchecks + cancelled_charged_subchecks. 0 when the check is not priced per subcheck',
      },
      {
        name: 'cancelled_no_charge_subchecks',
        description:
          'Subchecks on this rate whose check is tagged no charge. Not included in total_subchecks',
      },
      { name: 'quantity', description: 'Number of billing lines charged at unit_price' },
      { name: 'total_price', description: 'quantity × unit_price' },
    ],
  },
  {
    name: 'Credit purchases',
    value: 'credit_purchases',
    description:
      'Sum of credit top-ups and manual deductions for prepaid credit checks in the chosen period.',
    row_description: 'Company check',
    columns: [
      { name: 'Company ID', description: 'Company ID' },
      { name: 'Company', description: 'Company name' },
      { name: 'Check type', description: 'Check title' },
      { name: 'Check code', description: 'Check code' },
      { name: 'Credits added', description: 'Credits topped up in the period' },
      { name: 'Credits deducted', description: 'Credits manually deducted in the period' },
      { name: 'Net credits', description: 'Credits added minus credits deducted' },
    ],
    notes: [
      'Only company checks with payment type prepaid credits. On-account, subscription, and no-charge checks are excluded.',
    ],
  },
  {
    name: 'Credit purchase entries',
    value: 'credit_purchase_entries',
    description:
      'Each credit top-up and manual deduction for prepaid credit checks in the chosen period.',
    row_description: 'Credit purchase',
    columns: [
      { name: 'Company ID', description: 'Company ID' },
      { name: 'Company', description: 'Company name' },
      { name: 'Check type', description: 'Check title' },
      { name: 'Check code', description: 'Check code' },
      { name: 'Date', description: 'When the credits were added or deducted' },
      { name: 'Required by', description: 'Company user the credits were added for' },
      { name: 'Updated by', description: 'Name of the user who added or deducted the credits' },
      { name: 'Action', description: 'Added or Deducted' },
      { name: 'Credits', description: 'Number of credits added or deducted' },
    ],
    notes: [
      'One row per top-up or admin deduction. Check usage is not included.',
      'Only company checks with payment type prepaid credits. On-account, subscription, and no-charge checks are excluded.',
    ],
  },
  {
    name: 'Companies credits',
    value: 'clients_credits',
    description: 'Report for getting checks credits for each company',
    row_description: 'Company',
    columns: [
      { name: 'ID', description: 'Company ID' },
      { name: 'Company', description: 'Company Name' },
      { name: 'Owner email', description: 'Company main user email' },
      { name: '...{Check title}', description: 'Company check credit' },
    ],
    notes: ['Date filters are ignored'],
  },
  {
    name: 'Sign Ups',
    value: 'sign_ups',
    description: 'Report for getting sign-ups for the choosen period.',
    row_description: 'Company',
    columns: [
      { name: 'ID', description: 'Company ID' },
      { name: 'Company', description: 'Company Name' },
      { name: 'Created at', description: 'Company creation date' },
      { name: 'User name', description: 'User name' },
      { name: 'User email', description: 'User email' },
      { name: 'User phone number', description: 'User contact number' },
      { name: 'Email verified', description: 'Email verified' },
      { name: 'UTM source', description: 'UTM source' },
      { name: 'Last login', description: 'Last login date' },
    ],
  },
  {
    name: 'Active users',
    value: 'active_users',
    description: 'Report for getting verified users.',
    row_description: 'User',
    columns: [
      { name: 'Company', description: 'Company Name' },
      { name: 'User ID', description: 'Company creation date' },
      { name: 'User name', description: 'User name' },
      { name: 'User email', description: 'User email' },
      { name: 'User phone number', description: 'User contact number' },
    ],
    notes: ['Date filters are ignored'],
  },
  {
    name: 'Low usage report',
    value: 'low_usage',
    description: 'Report for getting company checks with low credits (< 10).',
    row_description: 'Company Check',
    columns: [
      { name: 'ID', description: 'Company ID' },
      { name: 'Company', description: 'Company Name' },
      { name: 'Owner email', description: 'Company main user email' },
      { name: 'Check type', description: 'Check title' },
      { name: 'Credit left', description: 'Remaining credits' },
    ],
    notes: ['Date filters are ignored'],
  },
  {
    name: 'Spend / Commission report',
    value: 'spend_commission',
    description: 'Report for getting company check usages and cost/pricing margins.',
    row_description: 'Company Check',
    columns: [
      { name: 'Company ID', description: 'Company ID' },
      { name: 'Company name', description: 'Company Name' },
      { name: 'Sign-up date', description: 'Company created date' },
      { name: 'Account Manager', description: 'Sales rep. configures in admin' },
      {
        name: 'Account type',
        description: 'Company account type (simple / enterprise / internal / demo / sandbox)',
      },
      {
        name: 'Payment type',
        description:
          'Company check payment type (on_account / prepaid_credits / subscription / no_charge)',
      },
      { name: 'Check title', description: 'Check title' },
      { name: 'First used on', description: 'Date of first usage of check type' },
      { name: 'Last used on', description: 'Date of last usage of check type' },
      { name: 'Volume', description: 'Amount of checks launched' },
      {
        name: 'Unit pricing',
        description:
          'Check price. If custom pricing set, use it. Else, use default check type pricing',
      },
      { name: 'Total pricing', description: '[Unit pricing] * [Volume]' },
      { name: 'Unit cost', description: 'Check type cost' },
      { name: 'Total cost', description: '[Unit cost] * [Volume]' },
      { name: 'Unit revenue', description: '[Unit pricing] - [Unit cost]' },
      { name: 'Total revenue', description: '([Unit pricing] - [Unit cost]) * [Volume]' },
    ],
    notes: [
      "If company has a currency different than 'NZD', cost and revenue might not be accurate as check costs are only set in 'NZD'",
    ],
  },
  {
    name: 'Checks volume',
    value: 'checks_volume_report',
    description: 'Report for getting volume of checks (by type) launched in the chosen period.',
    row_description: 'Check Type',
    columns: [
      { name: 'Check Type', description: 'Check title' },
      { name: 'Volume', description: 'Checks launched' },
    ],
  },
  {
    name: 'Partners usage',
    value: 'partners_usage_report',
    description:
      'Report for getting volume of checks per partner used by companies in the chosen period.',
    row_description: 'Check Type',
    columns: [
      { name: 'Company ID', description: 'Company ID' },
      { name: 'Company name', description: 'Company Name' },
      { name: 'Partner', description: 'Partner' },
      { name: 'Usages', description: 'Usages' },
    ],
  },
];
